const articleImage = () => {
  const prefix = `article_image`,
    component = document.querySelectorAll(`.${prefix}`);

  if (exists(`.${prefix}`)) {
    for (let i = 0; i < component.length; i++) {
      const componentIndex = component[i],
        imgSrc = componentIndex.getAttribute('data-src'),
        imgAlt = componentIndex.getAttribute('data-alt') ? componentIndex.getAttribute('data-alt') : null,
        imgCaption = componentIndex.getAttribute('data-caption');

      if (imgSrc) {
        var figure = new Element({
          type: 'figure',
          append: {
            parent: componentIndex
          },
        });

        var img = new Element({
          type: 'img',
          src: imgSrc,
          alt: imgAlt,
          append: {
            parent: figure,
          },
        });

        if (imgCaption) {
          var caption = new Element({
            type: 'figcaption',
            content: imgCaption,
            append: {
              parent: figure
            },
          });
        }
      }
    };
  };
};
articleImage();